import { HTTP_TOKEN_REPORT } from "./http";

export const getProducts = (params) => {
  return HTTP_TOKEN_REPORT.get("product", { params }).then((result) => {
    return result.data;
  });
};

export const getProduct = (product_id) => {
  return HTTP_TOKEN_REPORT.get(`product/${product_id}`).then((result) => {
    return result.data;
  });
};

export const updateProduct = (product_id, data) => {
  return HTTP_TOKEN_REPORT.put(`product/${product_id}`, data).then((result) => {
    return result.data;
  });
};

// campaigns

export const getAllCampaignsProduct = (product_id) => {
  return HTTP_TOKEN_REPORT.get(`product/${product_id}/campaign`).then(
    (result) => {
      return result.data;
    }
  );
};

export const updateProductCampaign = (product_id, data) => {
  return HTTP_TOKEN_REPORT.put(`product/${product_id}/campaign`, data).then(
    (result) => {
      return result.data;
    }
  );
};

export const updateProductCampaignMassive = (product_id, data) => {
  return HTTP_TOKEN_REPORT.put(
    `product/${product_id}/campaign/massive`,
    data
  ).then((result) => {
    return result.data;
  });
};

// variant
export const getAllProductVariant = (product_id) => {
  return HTTP_TOKEN_REPORT.get(`product/${product_id}/variant`).then(
    (result) => {
      return result.data;
    }
  );
};

export const updateProductVariant = (product_id, data) => {
  return HTTP_TOKEN_REPORT.put(`product/${product_id}/variant`, data).then(
    (result) => {
      return result.data;
    }
  );
};

export const updateProductVariantMassive = (product_id, data) => {
  return HTTP_TOKEN_REPORT.put(
    `product/${product_id}/variant/massive`,
    data
  ).then((result) => {
    return result.data;
  });
};
